export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/83e791c702f67cc0242109b04d241be7.svg";